module.exports = __webpack_public_path__ + "img/tianyan2026.png";